export const subMenuListFeatureTranslationEN = {
  SubMenuGroupListFeature: {
    Component: {
      csv_output: 'csv output',
      delete: 'delete',
      close: 'close',
      setting: 'setting',
      search: 'search',
      reload: 'reload',
      detail: 'detail',
      save: 'save',
    },
    Text: {
      list_of_submenu_groups: 'list of submenu groups',
      name: 'name:',
      all: 'all',
      submenu_group_details: 'submenu group details',
      default_configuration: 'default configuration',
      submenu_name: 'submenu name',
      setting_priority_order: 'setting priority order',
      kalbi: 'kalbi',
      selection_condition: 'selection condition',
      mandatory_selection: 'mandatory selection',
      single_control: 'single control',
      single_control_mandatory: 'single control mandatory',
      japanese: 'japanese',
      english: 'english',
      simplified_chinese: 'simplified chinese',
      traditional_chinese: 'traditional chinese',
      korean: 'korean',
      vietnamese: 'vietnamese',
      display_name: 'display_name',
      default_selection: 'default selection',
    },
    Table: {
      selection: 'selection',
      group_name: 'group name',
      assigned_menu: 'assigned menu',
      remarks: 'remarks',
      selection_condition: 'selection condition',
      mandatory_selection: 'mandatory selection',
      single_control: 'single control',
      single_control_mandatory: 'single control mandatory',
      default_selection: 'default selection',
      menu_type: 'type of menu',
    },
  },
};
